import { MaterialsIndexRouteView } from './view';

export const indexRoute = {
  index: true,
  element: <MaterialsIndexRouteView/>,
};